<ng-content select="[start]" />

<ctx-chemical-thumbnail [size]="size()" [chemical]="chemical()" />

<div class="chemical-row__information">
	<p class="m-0 font-size-medium">
		{{ chemical().name }}
	</p>

	<small class="chemical-row__information-label h-4">
		@if (showRevision()) {
			@if (
				chemical() | chemicalLatestRevision | async;
				as latestRevision
			) {
				{{ latestRevision.regulationNumber }}

				@if (latestRevision.expiresAt.toDate(); as expiresAt) {
					<span class="margin-h-1">•</span>

					@if (expiresAt | isExpired) {
						<span class="text-red-500">
							{{
								'data.expired-on'
									| transloco
										: { date: expiresAt | date: 'longDate' }
							}}
						</span>
					} @else {
						{{
							'data.expires-on'
								| transloco
									: { date: expiresAt | date: 'longDate' }
						}}
					}
				}
			}
		} @else {
			{{ chemical().activeIngredient }}
		}
	</small>
</div>

<div class="chemical-row__actions">
	@if (asTableRow()) {
		@if (interactable()) {
			<tui-icon icon="@tui.arrow-right" />
		}
	} @else {
		<ng-content select="[end]" />
	}
</div>
